import { Label } from "../../pages/Login/styles";
import { AddContainer } from "./styles";
import { Input, SelectInput } from "../Input/styles";
import { Button } from "../Button/styles";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MiniErrors } from "../MiniErrors/styles";
import api from "../../services/api";

function AddTechModal({ user, setUser, isAdding, setIsAdding }) {
  const formSchema = yup.object().shape({
    title: yup.string().required("Nome obrigatório").max(20),
    status: yup.string().matches(/^((?!default).)*$/s, "Campo obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const onSubmitFunction = (data) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    api
      .post("/users/techs", data, config)
      .then((res) => {
        setIsAdding(false);
        handleRefresh();
      })
      .catch((err) => console.log(err));
  };
  function handleRefresh() {
    api
      .get(`/users/${user.id}`)
      .then((res) => {
        setUser(res.data);
      })
      .catch((err) => console.log(err));
  }

  return (
    <>
      <AddContainer>
        <div
          style={{
            height: "40px",
            backgroundColor: "#343B41",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            borderBottom: "1px solid white",
          }}
        >
          <p style={{ fontSize: "17px", fontFamily: "Inter", color: "white" }}>
            Cadastrar Tecnologia
          </p>
          <button
            onClick={() => setIsAdding(false)}
            style={{
              backgroundColor: "transparent",
              border: "0",
              color: "#868E96",
              cursor: "pointer",
            }}
          >
            X
          </button>
        </div>
        <div style={{ heigth: "240px" }}>
          <form
            onSubmit={handleSubmit(onSubmitFunction)}
            style={{
              height: "240px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <div>
              <Label>
                Nome{" "}
                {errors.title && (
                  <MiniErrors> {errors.title.message}</MiniErrors>
                )}
              </Label>
              <Input {...register("title")} />
            </div>
            <div>
              <Label>
                Selecionar Status{" "}
                {errors.status && (
                  <MiniErrors> {errors.status.message}</MiniErrors>
                )}
              </Label>
              <SelectInput defaultValue="default" {...register("status")}>
                <option value="default" disabled>
                  Selecionar Status
                </option>
                <option value="Iniciante">Iniciante</option>
                <option value="Intermediário">Intermediário</option>
                <option value="Avançado">Avançado</option>
              </SelectInput>
            </div>
            <Button type="submit" backgroundColor="#FF577F" fontSize="18px">
              Cadastrar Tecnologia
            </Button>
          </form>
        </div>
      </AddContainer>
    </>
  );
}
export default AddTechModal;
